import { makeStyles } from '@material-ui/styles'
import React from 'react'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Checkbox from 'core/elements/input/Checkbox'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import deleteVmStyles from './deleteVmStyles'

const useStyles = makeStyles<Theme>((theme) => ({
  ...deleteVmStyles(theme),
}))

export default function RootView({
  vmVolumes,
  vmPorts,
  goToDetailedView,
  deleteAssociatedResources,
  setDeleteAssociatedResources,
}) {
  const classes = useStyles()
  return (
    <>
      <Text variant="body2">This action cannot be undone</Text>
      <Text variant="body2">
        <b>NOTE:</b> If any volumes to be deleted have a dependent snapshot, VM deletion will take
        longer as the volume snapshots are cleaned up.
      </Text>
      <div className={classes.overviewBox}>
        <div className={classes.topBox}>
          <div>
            <Text variant="body2">
              Associated volumes: <b>{vmVolumes?.length}</b>
            </Text>
            <Text variant="body2">
              Associated ports: <b>{vmPorts?.length}</b>
            </Text>
          </div>
          <div className={classes.topBoxLinkContainer}>
            <Text variant="caption1" className={classes.boxLink} onClick={goToDetailedView}>
              Select Resources
              <FontAwesomeIcon className={classes.caret} size="md" regular>
                chevron-right
              </FontAwesomeIcon>
            </Text>
          </div>
        </div>
        <div className={classes.divider} />
        <div>
          <Checkbox
            className={classes.checkbox}
            label="Also delete associated resources"
            checked={deleteAssociatedResources}
            onChange={setDeleteAssociatedResources}
            textWeight="light"
          />
        </div>
      </div>
    </>
  )
}
